export default __webpack_public_path__ + "static/media/8.0d9af9fb.png";